import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import { capitalize } from '../../utils/string';

const MenuDetailPanel = ({ rowData }) => {
  const { meals, entities } = rowData;

  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', margin: 16 }}>
      <Card style={{ flex: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontSize: 14 }}>Meal</TableCell>
              <TableCell style={{ fontSize: 14 }}>Food</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { meals.map(meal => meal.foods.map((food, index) => (
              <TableRow key={index}>
                <TableCell component='th' scope='row' style={{ fontSize: 14 }}>{meal.formattedMealtime}</TableCell>
                <TableCell style={{ fontSize: 14 }}>{food.split(' ').map(str => capitalize(str)).join(' ')}</TableCell>
              </TableRow>
            )))}
          </TableBody>
        </Table>
      </Card>
      <Card style={{ marginLeft: 16 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontSize: 14 }}>Who this menu is applied to</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { entities.map((entitiy, index) => (
              <TableRow key={index}>
                <TableCell component='th' scope='row' style={{ fontSize: 14 }}>{entitiy.name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
};

export default MenuDetailPanel;
